import { Guid } from 'guid-typescript';

export class Country {
  id?: Guid;
  description: string;
  code: string;
  phoneCode: string;
}
